module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/return-policy/return-policy-list/return-policy-list.component.css
// module id = ./src/app/return-policy/return-policy-list/return-policy-list.component.css
// module chunks = main